import React, { useState, useEffect } from 'react';
import { getMeals, createMeal, updateMeal, deleteMeal } from '../services/api';

const MealManager = () => {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    meal_type: 'breakfast'
  });
  const [editMode, setEditMode] = useState(false);
  const [currentMealId, setCurrentMealId] = useState(null);

  useEffect(() => {
    fetchMeals();
  }, []);

  const fetchMeals = async () => {
    try {
      setLoading(true);
      const response = await getMeals();
      setMeals(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching meals:', error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await updateMeal(currentMealId, formData);
      } else {
        await createMeal(formData);
      }
      resetForm();
      fetchMeals();
    } catch (error) {
      console.error('Error saving meal:', error);
    }
  };

  const handleEdit = (meal) => {
    setFormData({
      name: meal.name,
      description: meal.description || '',
      meal_type: meal.meal_type
    });
    setEditMode(true);
    setCurrentMealId(meal.id);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this meal?')) {
      try {
        await deleteMeal(id);
        fetchMeals();
      } catch (error) {
        console.error('Error deleting meal:', error);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      meal_type: 'breakfast'
    });
    setEditMode(false);
    setCurrentMealId(null);
  };

  return (
    <div className="meal-manager">
      <h2>{editMode ? 'Edit Meal' : 'Add New Meal'}</h2>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Meal Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="3"
          ></textarea>
        </div>
        <div className="mb-3">
          <label htmlFor="meal_type" className="form-label">Meal Type</label>
          <select
            className="form-select"
            id="meal_type"
            name="meal_type"
            value={formData.meal_type}
            onChange={handleInputChange}
            required
          >
            <option value="breakfast">Breakfast</option>
            <option value="lunch">Lunch</option>
            <option value="dinner">Dinner</option>
          </select>
        </div>
        <div className="d-flex">
          <button type="submit" className="btn btn-primary me-2">
            {editMode ? 'Update Meal' : 'Save Meal'}
          </button>
          {editMode && (
            <button type="button" className="btn btn-secondary" onClick={resetForm}>
              Cancel
            </button>
          )}
        </div>
      </form>

      <h2 className="mb-3">Meals List</h2>
      {loading ? (
        <p>Loading meals...</p>
      ) : (
        <div className="row">
          {meals.length === 0 ? (
            <p>No meals found. Please add some meals.</p>
          ) : (
            meals.map((meal) => (
              <div key={meal.id} className="col-md-4 mb-3">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">{meal.name}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">
                      {meal.meal_type.charAt(0).toUpperCase() + meal.meal_type.slice(1)}
                    </h6>
                    <p className="card-text">{meal.description}</p>
                    <div className="d-flex">
                      <button
                        onClick={() => handleEdit(meal)}
                        className="btn btn-sm btn-outline-primary me-2"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(meal.id)}
                        className="btn btn-sm btn-outline-danger"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default MealManager; 